import { Box, Button, Grid, Tooltip } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import React, { useLayoutEffect, useReducer } from "react";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";
import CustomDateField from "../../CustomComponents/CustomDateField";
import CustomTextField from "../../CustomComponents/CustomTextField";
import { useRef } from "react";
import { useEffect } from "react";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";

const filterValues = {
  tabIndex: "tabIndex",
  branch: "branch",
  applicationNum: "applicationNum",
  loanType: "loanType",
  customerName: "customerName",
  coApplicantName: "coApplicantName",
  customerId: "customerId",
  losStatus: "losStatus",
  effectiveDate: "effectiveDate",
  applicationDateFromValue: "applicationDateFromValue",
  applicationDateToValue: "applicationDateToValue",
  applicationDate: "applicationDate",
  customerType: "customerType",
  rateOfInterest: "rateOfInterest",
  loanAmt: "loanAmt",
  sanctionAmt: "sanctionAmt",
  disbursementDateFromValue: "disbursementDateFromValue",
  disbursementDateToValue: "disbursementDateToValue",
  requestNumber: "requestNumber",
  disbursementStatus: "disbursementStatus",
};

var today = new Date();

const FilterCondition = (props) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case filterValues.tabIndex:
        return { ...state, tabIndex: action.value };
      case filterValues.branch:
        return { ...state, branch: action.value };
      case filterValues.applicationNum:
        return { ...state, applicationNum: action.value };
      case filterValues.customerName:
        return { ...state, customerName: action.value };
      case filterValues.loanType:
        return { ...state, loanType: action.value };
      case filterValues.coApplicantName:
        return { ...state, coApplicantName: action.value };
      case filterValues.customerId:
        return { ...state, customerId: action.value };
      case filterValues.losStatus:
        return { ...state, losStatus: action.value };
      case filterValues.effectiveDate:
        return { ...state, effectiveDate: action.value };
      case filterValues.applicationDate:
        return { ...state, applicationDate: action.value };
      case filterValues.applicationDateFromValue:
        return { ...state, applicationDateFromValue: action.value };
      case filterValues.applicationDateToValue:
        return { ...state, applicationDateToValue: action.value };
      case filterValues.customerType:
        return { ...state, customerType: action.value };
      case filterValues.rateOfInterest:
        return { ...state, rateOfInterest: action.value };
      case filterValues.loanAmt:
        return { ...state, loanAmt: action.value };
      case filterValues.sanctionAmt:
        return { ...state, sanctionAmt: action.value };
      case filterValues.disbursementDateFromValue:
        return { ...state, disbursementDateFromValue: action.value };
      case filterValues.disbursementDateToValue:
        return { ...state, disbursementDateToValue: action.value };
      case filterValues.disbursementStatus:
        return { ...state, disbursementStatus: action.value };
      case filterValues.requestNumber:
        return { ...state, requestNumber: action.value };
      default:
        return { ...props.initialState, tabIndex: state.tabIndex };
    }
  };

  useLayoutEffect(() => {
    if (props.mode !== "Detail") {
      // don't trigger on detail page load.
      updateFieldsData(filterValues.branch, state.branch);
    }
    if (
      props.listScreenMode === "SANCTIONEDLIST" &&
      props.initialState.sanctionList.length === 1
    ) {
      setSearchDisabled(true);
    } else if (
      props.listScreenMode !== "SANCTIONEDLIST" &&
      props.datarows.length === 1
    ) {
      setSearchDisabled(true);
    }
  }, [props.initialState]);

  const updateAutoCompleteFields = (field, value) => {
    // clear other autofields set.
    updateFieldsData(filterValues.branch, null);
    // on branch change need to load data from backend so dispatch event back to parent.
    if (field === filterValues.branch) {
      props.onBranchChange(value);
    }
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const updateFieldsData = (field, value) => {
    let dataList = value
      ? [...props.initialState.disbursementList].filter((row) =>
          field === filterValues.branch
            ? row["branchCode"] === getSelectedBranchCode(value)
            : row[field] === value
        )
      : field === filterValues.branch
      ? []
      : // the other case is clear of application number
        [...props.initialState.disbursementList].filter(
          (row) => row.branchCode === getSelectedBranchCode(state.branch)
        );
    if (dataList.length > 1) {
      // based on branch select dynamic load of application numbers
      if (!value && field === filterValues.applicationNum) {
        removeSelectedData(dataList, value, field);
      } else if (!value && field === filterValues.requestNumber) {
        removeSelectedData(dataList, value, field);
        dataList = [...dataList].filter(
          (row) => row.applicationNum === state.applicationNum
        );
      } else if (field === filterValues.branch && !value) {
        // on branch change.
        dispatch({ type: "", value: "" });
        dispatch({
          type: filterValues.branch,
          value: !value ? null : value,
        });
        removeSelectedData([], value, field);
      }
      const applicationNumsData = [
        ...Array.from(
          new Set(dataList.map((row) => row.applicationNum).sort())
        ).map((applicationNum) => {
          return {
            label: applicationNum,
          };
        }),
      ];
      loadapplicationNums(applicationNumsData);
      // dynamic load of customer names
      const applicantNames = [
        ...Array.from(new Set(dataList.map((row) => row.customerName))).map(
          (customerName) => {
            return {
              label: customerName,
            };
          }
        ),
      ];
      loadApplicantNames(applicantNames);
      // dynmaic load of reference numbers.
      const requestNumbers = [
        ...Array.from(new Set(dataList.map((row) => row.requestNumber))).map(
          (requestNumber) => {
            return {
              label: String(requestNumber),
            };
          }
        ),
      ];
      loadrequestNumbers(requestNumbers);
      // dynamic load of status.
      const status = [
        ...Array.from(
          new Set(dataList.map((row) => row.disbursementStatus))
        ).map((status) => {
          return {
            label: status,
          };
        }),
      ];
      loadDisbursementRecordsStatus(status);
      setSearchDisabled(false);
    } else if (dataList.length === 1 || !value) {
      removeSelectedData(dataList, value, field);
      loadapplicationNums(
        !value
          ? field === filterValues.branch
            ? []
            : [{ label: dataList.at(0).applicationNum }]
          : [{ label: dataList.at(0).applicationNum }]
      );
      loadApplicantNames(
        !value
          ? field === filterValues.branch
            ? []
            : [{ label: dataList.at(0).customerName }]
          : [{ label: dataList.at(0).customerName }]
      );
      loadrequestNumbers(
        !value
          ? field === filterValues.branch
            ? []
            : [{ label: String(dataList.at(0).requestNumber) }]
          : [{ label: String(dataList.at(0).requestNumber) }]
      );
      loadDisbursementRecordsStatus(
        !value
          ? field === filterValues.branch
            ? []
            : [{ label: dataList.at(0).disbursementStatus }]
          : [{ label: dataList.at(0).disbursementStatus }]
      );
      setSearchDisabled(true);
    }
  };

  const removeSelectedData = (dataList, value, field) => {
    // if (field !== filterValues.requestNumber) {
    dispatch({
      type: filterValues.applicationNum,
      value:
        !value || dataList.length === 0 ? null : dataList.at(0).applicationNum,
    });
    // }
    dispatch({
      type: filterValues.customerName,
      value:
        !value || dataList.length === 0 ? null : dataList.at(0).customerName,
    });
    dispatch({
      type: filterValues.loanType,
      value: !value || dataList.length === 0 ? null : dataList.at(0).loanType,
    });
    dispatch({
      type: filterValues.requestNumber,
      value:
        !value || dataList.length === 0
          ? null
          : String(dataList.at(0).requestNumber),
    });
    dispatch({
      type: filterValues.disbursementStatus,
      value:
        !value || dataList.length === 0
          ? null
          : dataList.at(0).disbursementStatus,
    });

    if (!props.disDetailPage) {
      let disbursementDateValue = null;
      if (!value || dataList.length === 0) {
        disbursementDateValue = null;
      } else {
        // month is 0-based, that's why we need dataParts[1] - 1
        var dateString = dataList.at(0).disbursementDate;
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          +dateParts[2],
          dateParts[1] - 1,
          +dateParts[0]
        );
        disbursementDateValue = dayjs(dateObject);
      }

      dispatch({
        type: filterValues.disbursementDateFromValue,
        value: disbursementDateValue,
      });
    }

    if (props.disDetailPage) {
      dispatch({
        type: filterValues.customerType,
        value:
          !value || dataList.length === 0 ? "" : dataList.at(0).customerType,
      });
      dispatch({
        type: filterValues.loanAmt,
        value: !value || dataList.length === 0 ? "" : dataList.at(0).loanAmt,
      });
      dispatch({
        type: filterValues.sanctionAmt,
        value:
          !value || dataList.length === 0 ? "" : dataList.at(0).sanctionAmt,
      });
      dispatch({
        type: filterValues.rateOfInterest,
        value:
          !value || dataList.length === 0 ? "" : dataList.at(0).rateOfInterest,
      });
      dispatch({
        type: filterValues.applicationDate,
        value:
          !value || dataList.length === 0
            ? null
            : dataList.at(0).applicationDate,
      });
    }
  };

  const [state, dispatch] = useReducer(reducer, props.initialState);
  const disabledState = !(props.mode === "Search");
  const [applicationNums, loadapplicationNums] = React.useState([]);
  const [applicantNames, loadApplicantNames] = React.useState([]);
  const [requestNumbers, loadrequestNumbers] = React.useState([]);
  const [disbursementStatus, loadDisbursementRecordsStatus] = React.useState(
    []
  );
  const [disableSearchFields, setSearchDisabled] = React.useState(false);
  const [branchHasError, setBranchHasError] = React.useState(false);
  const [applicationDateValidDateError, setApplicationDateValidDateError] =
    React.useState(false);
  const [disbursementDateValidDateError, setDisbursementDateValidDateError] =
    React.useState(false);

  const searchButtonClickHandler = (event) => {
    event.preventDefault();
    let errorExist = false;
    if (
      state.branch !== "" &&
      state.branch !== null &&
      state.branch !== undefined
    ) {
      setBranchHasError(false);
    } else {
      errorExist = true;
      setBranchHasError(true);
    }

    if (!props.disDetailPage) {
      // disbursement list screen.
      if (disbursementDateValidDateError) {
        errorExist = true;
      }
    } else {
      if (applicationDateValidDateError) {
        errorExist = true;
      }
    }

    if (!errorExist) {
      // no error exist dispatch search event.
      props.onSearchButtonClick(state);
    }
  };

  const AdvancedSearchValues = (
    <>
      <Box>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={disabledState}
              required={true && !disabledState}
              label="Branch"
              id="branch"
              variant="standard"
              type="text"
              placeholder="Select Branch"
              autoCompleteValues={state.branchNames}
              value={state.branch}
              onChange={(event, value) => {
                dispatch({
                  type: filterValues.branch,
                  value: value === null ? value : value.label,
                });
                updateAutoCompleteFields(
                  filterValues.branch,
                  value === null ? value : value.label
                );
                setBranchHasError(
                  value !== null && value !== "" && value !== undefined
                    ? false
                    : true
                );
              }}
            />
            {branchHasError && <p className="error">Please Select Branch</p>}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={disabledState}
              required={false}
              label="Application Number"
              id="applicationNum"
              variant="standard"
              type="text"
              placeholder="Select Application Number"
              autoCompleteValues={applicationNums}
              value={state.applicationNum}
              onChange={(event, value) => {
                dispatch({
                  type: filterValues.applicationNum,
                  value: value === null ? value : value.label,
                });
                updateFieldsData(
                  filterValues.applicationNum,
                  value === null ? value : value.label
                );
                if (value === null || value === undefined || value === "") {
                  updateAutoCompleteFields(filterValues.branch, state.branch);
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={disabledState || disableSearchFields}
              required={false}
              label="Applicant Name"
              id="customerName"
              variant="standard"
              value={state.customerName}
              type="text"
              placeholder="Select Applicant Name"
              autoCompleteValues={applicantNames}
              onChange={(event, value) => {
                dispatch({
                  type: filterValues.customerName,
                  value: value === null ? value : value.label,
                });
              }}
            />
          </Grid>

          {props.disDetailPage && (
            <React.Fragment>
              {/* To Show other fields in view screen. */}
              {props.mode !== "Search" ? (
                <>
                  {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomTextField
                      disabled={disabledState}
                      required={false}
                      label="Co-Applicant Name"
                      id="coApplicantName"
                      variant="standard"
                      value={state.coApplicantName}
                      type="text"
                      placeholder="Enter Co-Applicant Name."
                      onChange={(event) => {
                        dispatch({
                          type: filterValues.coApplicantName,
                          value: event.target.value,
                        });
                      }}
                    />
                  </Grid> */}
                  {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomTextField
                      disabled={disabledState}
                      required={false}
                      label="Customer Id"
                      id="customerID"
                      variant="standard"
                      value={state.customerId}
                      type="text"
                      placeholder="Enter Customer Id."
                      onChange={(event) => {
                        dispatch({
                          type: filterValues.customerId,
                          value: event.target.value,
                        });
                      }}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomTextField
                      disabled={disabledState}
                      required={false}
                      label="Sanction Status"
                      id="losStatus"
                      variant="standard"
                      value={state.losStatus}
                      type="text"
                      placeholder="Enter Sanction Status."
                      onChange={(event) => {
                        dispatch({
                          type: filterValues.losStatus,
                          value: event.target.value,
                        });
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomDateField
                      disabled={disabledState}
                      required={false}
                      label="Effective Date"
                      id="effectiveDate"
                      variant="standard"
                      value={state.effectiveDate}
                      type="text"
                      placeholder="Enter Effective Date"
                    />
                  </Grid> */}
                </>
              ) : null}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  // disabled={disabledState || disableSearchFields}
                  disabled={true}
                  required={false}
                  label="Application Date"
                  id="applicationDate"
                  variant="standard"
                  value={state.applicationDate}
                  type="text"
                  placeholder="Enter Application Date"
                  onChange={(event) => {
                    dispatch({
                      type: filterValues.applicationDate,
                      value: event,
                    });
                    new Date(event).toDateString() !== "Invalid Date" &&
                    event !== null &&
                    new Date(event).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(event).toLocaleDateString().slice(-4) <= "2055"
                      ? setApplicationDateValidDateError(false)
                      : setApplicationDateValidDateError(true);
                  }}
                />
                {applicationDateValidDateError && (
                  <p className="error">Please Enter Valid Date</p>
                )}
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDropDown
                  disabled={disabledState || disableSearchFields}
                  required={false}
                  label="Customer Type"
                  id="customerType"
                  variant="standard"
                  type="text"
                  placeholder="Select Customer Type"
                  dropDownValue={[
                    { value: "New", text: "New" },
                    { value: "Old", text: "Old" },
                  ]}
                  value={state.customerType}
                  onChange={(event) => {
                    dispatch({
                      type: filterValues.customerType,
                      value: event.target.value,
                    });
                  }}
                />
              </Grid> */}

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={disabledState || disableSearchFields}
                  required={false}
                  label="Rate of Interest(%)"
                  id="rateOfInterest"
                  variant="standard"
                  value={state.rateOfInterest}
                  type="number"
                  placeholder="Enter Rate of Interest."
                  onChange={(event) => {
                    dispatch({
                      type: filterValues.rateOfInterest,
                      value: event.target.value,
                    });
                  }}
                />
              </Grid> */}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={disabledState || disableSearchFields}
                  required={false}
                  label="Sanctioned Loan Amount (₹)"
                  id="sanctionAmt"
                  variant="standard"
                  value={
                    state.sanctionAmt === ""
                      ? 0
                      : parseInt(state.sanctionAmt).toLocaleString("en-IN")
                  }
                  type="text"
                  placeholder="Enter Sanctioned Loan Amount"
                  onChange={(event) => {
                    const value = event.target.value;
                    const newValue = event.target.value.replaceAll(",", "");
                    dispatch({
                      type: filterValues.sanctionAmt,
                      value: isNaN(Number(newValue)) ? 0 : newValue,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  // disabled={disabledState || disableSearchFields}
                  disabled={true}
                  required={false}
                  label="Loan Type"
                  id="loanType"
                  variant="standard"
                  type="text"
                  placeholder="Select Loan Type"
                  autoCompleteValues={["NEW LOAN", "BALANCE TRANSFER"]}
                  value={state.loanType}
                  onChange={(event, value) => {
                    dispatch({
                      type: filterValues.loanType,
                      value: value === null ? value : value.label,
                    });
                  }}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={disabledState || disableSearchFields}
                  required={false}
                  label="Sanctioned Amount"
                  id="sanctionAmt"
                  variant="standard"
                  value={
                    state.sanctionAmt === ""
                      ? 0
                      : parseInt(state.sanctionAmt).toLocaleString("en-IN")
                  }
                  type="text"
                  placeholder="Enter Sanctioned Amount"
                  onChange={(event) => {
                    dispatch({
                      type: filterValues.sanctionAmt,
                      value: event.target.value.replaceAll(",", ""),
                    });
                  }}
                />
              </Grid> */}
            </React.Fragment>
          )}
          {/* disDetailPage page is false means it was the disbursement list screen search container */}
          {!props.disDetailPage && (
            <React.Fragment>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  disabled={disabledState}
                  required={false}
                  label="Request Number"
                  id="requestNumber"
                  variant="standard"
                  value={state.requestNumber}
                  type="text"
                  placeholder="Select Reference Number"
                  autoCompleteValues={requestNumbers}
                  onChange={(event, value) => {
                    dispatch({
                      type: filterValues.requestNumber,
                      value: value === null ? value : value.label,
                    });
                    updateFieldsData(
                      filterValues.requestNumber,
                      value === null ? value : value.label
                    );
                    if (value === null || value === undefined || value === "") {
                      updateAutoCompleteFields(
                        filterValues.branch,
                        state.branch
                      );
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  disabled={disabledState || disableSearchFields}
                  required={false}
                  label="Disbursement Status"
                  id="disbursementStatus"
                  variant="standard"
                  type="text"
                  placeholder="Select Disbursement Status"
                  autoCompleteValues={disbursementStatus}
                  value={state.disbursementStatus}
                  onChange={(event, value) => {
                    dispatch({
                      type: filterValues.disbursementStatus,
                      value: value === null ? value : value.label,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  // disabled={disabledState || disableSearchFields}
                  disabled={true}
                  required={false}
                  label="Disbursement Date"
                  id="disbursementDate"
                  variant="standard"
                  value={state.disbursementDateFromValue}
                  type="text"
                  placeholder="Enter Disbursement Date"
                  onChange={(event) => {
                    dispatch({
                      type: filterValues.disbursementDateFromValue,
                      value: event,
                    });
                    new Date(event).toDateString() !== "Invalid Date" &&
                    event !== null &&
                    new Date(event).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(event).toLocaleDateString().slice(-4) <= "2055"
                      ? setDisbursementDateValidDateError(false)
                      : setDisbursementDateValidDateError(true);
                  }}
                />
                {disbursementDateValidDateError && (
                  <p className="error">Please Enter Valid Date</p>
                )}
              </Grid>
            </React.Fragment>
          )}
        </Grid>
        {props.mode === "Search" ? (
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "0px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem" }}
                onClick={searchButtonClickHandler}
                ref={props.searchButtonRef}
              >
                {/* <Search /> */}
                Search
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  marginLeft: "1rem",
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={(event) => {
                  setBranchHasError(false);
                  dispatch({ type: "", value: "" });
                  props.onClearButtonClick();
                }}
                ref={props.clearRef}
              >
                {/* <Backspace sx={{ marginRight: "1rem" }} /> */}
                Clear
              </Button>
            </Tooltip>
          </Box>
        ) : null}
      </Box>
    </>
  );

  return (
    <>
      <AccordianContainer
        title={props.title}
        initialOpen={props.initialOpen}
        setAccordianOpen={props.setAccordianOpen}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            marginBottom: "8px",
            marginTop: "-2%",
          }}
        >
          {AdvancedSearchValues}
        </Box>
      </AccordianContainer>
    </>
  );
};

export default FilterCondition;
